import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import css from './all-classes.scss';
import ActivityStatusBar from '../../../components/activity-status-bar/activity-status-bar';
import TableHeader from '../../../components/table-header/table-header';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import {
    ACTIVITY_MASTERY,
    ALL_CLASSES,
    ALL_YEARS,
    NUM_ACTIVITIES,
    RESULTS
} from '../../../components/report-filters/filter-constants';

const CLASS_ID = 'id';
const CLASS_NAME = 'name';
const ACTIVITY_RESULTS = 'activityMastery';
const TOTAL_ACTIVITIES = 'activityMastery.totalActivities';

const ALL_CLASSES_TABLE_CONFIG = {
    cols: [
        {
            id: CLASS_NAME,
            name: getTranslationKey(ALL_CLASSES),
            doTranslation: true,
            sort: { sortAs: 'string' },
            classes: css['class-name'],
            truncate: true,
            onClick: () => null // this is set in the AllClasses component
        },
        {
            id: ACTIVITY_RESULTS,
            name: getTranslationKey(RESULTS),
            doTranslation: true,
            classes: css.results,
            headerTransform: () => null, // this is set in the AllClasses component
            transform: (row) => (
                <ActivityStatusBar activityMastery={row.activityMastery} />
            )
        },
        {
            id: TOTAL_ACTIVITIES,
            name: '' // this is set in the AllClasses component
        }
    ],
    colGroups: [
        [
            {
                name: ACTIVITY_MASTERY,
                headerTransform: () => (
                    <TableHeader
                        title={getTranslationKey(ACTIVITY_MASTERY)}
                        translate
                    />
                ),
                colIds: [CLASS_NAME, ACTIVITY_RESULTS]
            },
            {
                name: getTranslationKey(NUM_ACTIVITIES),
                colIds: [TOTAL_ACTIVITIES],
                doTranslation: true,
                classes: `text-center ${css['total-activities']}`
            }
        ]
    ],
    defaultSort: CLASS_NAME
};

const ALL_YEARS_TABLE_CONFIG = cloneDeep({
    ...ALL_CLASSES_TABLE_CONFIG,
    defaultSort: CLASS_ID
});
ALL_YEARS_TABLE_CONFIG.cols[0] = {
    ...ALL_YEARS_TABLE_CONFIG.cols[0],
    name: getTranslationKey(ALL_YEARS),
    doTranslation: true,
    id: CLASS_ID,
    transform: (row) => row[CLASS_NAME],
    sort: { sortAs: 'number' }
};

export {
    CLASS_ID,
    CLASS_NAME,
    ACTIVITY_RESULTS,
    TOTAL_ACTIVITIES,
    ALL_CLASSES_TABLE_CONFIG,
    ALL_YEARS_TABLE_CONFIG
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/all-classes/all-classes-constants.js